import { createContext, useContext } from "react";
import { ITeamToasterContext } from "./type";

const TeamToasterContext = createContext<ITeamToasterContext>(null);
export const useTeamToasterContext = () => useContext(TeamToasterContext);

export default TeamToasterContext;
